import React, { useEffect, useState } from "react"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import Container from "react-bootstrap/Container"
import { Link, matchPath, useLocation } from "react-router-dom"
import { LANGUAGES, ROUTES } from "constants/general"
import NavDropdown from "react-bootstrap/NavDropdown"
import localization from "utils/localization"

const NavBar = ({ language, onChangeLanguage }) => {
    const [navColour, updateNavbar] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false)
    let location = useLocation()

    useEffect(() => {
        const scrollHandler = () => {
            if (window.scrollY >= 20) updateNavbar(true)
            else updateNavbar(false)
        }

        window.addEventListener("scroll", scrollHandler)
        return () => {
            window.removeEventListener('scroll', scrollHandler)
        }
    }, [])

    return (
        <Navbar fixed="top" expand="md" expanded={ menuOpen } onToggle={ () => setMenuOpen(!menuOpen)}
            className={ navColour ? "sticky" : "navbar" } 
        >
            <Container>
                <Navbar.Brand href="/">
                    <strong className="main-name">RPS</strong>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav">
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>
                <Navbar.Collapse>
                    <Nav className="ml-auto" defaultActiveKey="/">
                        { ROUTES.map(route => (
                            <Nav.Item key={ route.label } className={ matchPath(location.pathname, {
                                path: route.to,
                                exact: true,
                                strict: true
                            }) ? 'open' : ''}>
                                <Nav.Link as={ Link } to={ route.to } onClick={ () => setMenuOpen(false) }>
                                    <route.Icon style={{ marginBottom: "2px" }}/> { localization(route.label) }
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                    <NavDropdown id="nav-dropdown-dark-example" title={ localization(language) } alignRight>
                        { LANGUAGES.map(val => (
                            <NavDropdown.Item key={ val } onClick={ () => onChangeLanguage(val) }>{ localization(val) }</NavDropdown.Item>
                        ))}
                    </NavDropdown>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default NavBar